import { ensureDate } from '../dates'

const DATE_FIELDS = [
  'scheduledStartAt',
  'scheduledEndAt',
  'advisorJoinedAt',
  'patientJoinedAt',
  'concludedAt'
]

export default function Visit(...params) {
  let visit = {
    appointmentId: null,
    scheduledStartAt: new Date(),
    scheduledEndAt: new Date(),
    advisorJoinedAt: null,
    patientJoinedAt: null,
    concludedAt: null,
    channel: null,
    queueId: null,
    removedFromQueue: false,
    removedByAdvisor: false
  }

  Object.assign(visit, ...params)

  DATE_FIELDS.forEach(key => {
    if (visit[key] != null) {
      visit[key] = ensureDate(visit[key])
    }
  })

  return visit
}
